module.exports = __webpack_public_path__ + "media/images/marketing/app_video_thumbnail4-ef16f5f53c0d15ab53c4335e642954552f23118f76d8b1a3603bd78c8b1f5cda.jpg";